import React from "react";
import { useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

// Svg
import PartyPapper from "../../../../Assets/Svg/Auth/PartyPapper.svg";

// Custom components
import FooterColorLine from "Components/FooterColorLine";
import Button from "Components/Button";

const PasswordSuccess = () => {
  // Initialize useNavigate
  const navigate = useNavigate();
  return (
    <>
      <div className="user-password-success-root-container">
        <img src={PartyPapper} alt="Party Popper" />
        <p className="user-success-text">SUCCESS!</p>
        <p className="user-message-text">
          Your password has been successfully updated. Now you can explore KG
          Maintenance Assessment Portal.
        </p>
        <Button
          onClick={() => navigate("/", { replace: true })}
          title="Explore"
          buttonStyle={{ width: "30%" }}
        />
      </div>
      <div className="user-footer">
        <FooterColorLine />
      </div>
    </>
  );
};

export default PasswordSuccess;
